import { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {
  Box,
  ListItemText,
  MenuItem,
  Pagination,
  Stack, TextField,
  Typography,
} from '@mui/material';
import { SimFormSelect } from '../Bootstrap';


const rowsPerPageOptions  = [10 , 20, 30, 40];

// ================================|| Sim Pagination ||================================ //
SimPagination.propTypes = {
  total: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  page: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  rowsPerPage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChangePage: PropTypes.func,
  onChangeRowsPerPage: PropTypes.func,
  onQuickJumper: PropTypes.func,
  limit: PropTypes.number,
  hideRowsPerPage: PropTypes.bool,
  hideJumper: PropTypes.bool,
};
export default function SimPagination({ total = 0, page = 1, rowsPerPage = 10, count = 0, onChangePage = () => Promise.resolve(), onChangeRowsPerPage = () => Promise.resolve(), onQuickJumper, limit = 10, disableScrollTop = false, hideRowsPerPage = false, hideJumper = false }) {
  const theme = useTheme();
  const { t } = useTranslation();

  const [rowsPage, setRowsPage] = useState(rowsPerPage);

  // 每页显示的条数
  const handlePerPageChange = (event) => {
    onChangeRowsPerPage(event, event.target.value)
    setRowsPage(event.target.value);
  };

  const handleChangePage = async (event, ev) => {
    await ((!disableScrollTop) && window.scrollTo({ top: 0, behavior: 'smooth' }));
    await onChangePage(event, ev);
  };
  

  return (
    <Stack spacing={3}>
      {
        total > limit && (
          <Stack width={'100%'} direction={'row'} spacing={1} py={4} alignItems={'center'} justifyContent={'center'}>
            <Typography variant={'h6'} fontWeight={400}>
              共{ total }筆
            </Typography>
            <Pagination
              // siblingCount={3}
              variant={'text'}
              shape="rounded"
              size={'medium'}
              count={count}
              page={page}
              defaultPage={page}
              onChange={handleChangePage}
            />
            <Box display={'flex'} alignItems={'center'} maxHeight={32}>
              {
                (!hideRowsPerPage) && (
                  <SimFormSelect
                    id='sim-pagination-signle-select'
                    label-id='sim-pagination-signle-select-label'
                    size={'small'}
                    aria-label=""
                    placeholder=''
                    variant='outlined'
                    value={rowsPage}
                    onChange={handlePerPageChange}
                    renderValue={(selected) => {
                      if (selected?.length === 0) {
                        return <Typography variant={'body1'} color={theme.palette.text.disabled}>請選擇</Typography>;
                      }
                      return `${rowsPerPageOptions?.find(option => option === selected)} 筆/頁`;
                    }}
                    sx={{
                      mx: 1,
                      '& .MuiSelect-select': {
                        maxHeight: 32,
                        maxWidth: 64,
                        py: 0.5,
                        color: theme.palette.grey[600]
                      }
                    }}
                  >
                    {rowsPerPageOptions?.map(option  => (
                      <MenuItem key={option} value={option}>
                        <ListItemText primary={option} />
                      </MenuItem>
                    ))}
                  </SimFormSelect>
                )
              }
              
              {
                (!hideJumper) && (
                  <>
                    <Typography variant={'h6'} fontWeight={400} color={'common.black'}>跳至</Typography>
                    <TextField
                      type='number'
                      onBlur={async (event) => {
                        await ((!disableScrollTop) && window.scrollTo({ top: 0, behavior: 'smooth' }));
                        await onQuickJumper(event)
                      }}
                      onKeyDown={async (event) => {
                        if (event.key === 'Enter') {
                          await ((!disableScrollTop) && window.scrollTo({ top: 0, behavior: 'smooth' }));
                          await onQuickJumper(event);
                        }
                      }}
                      id="outlined-size-small"
                      defaultValue=""
                      size="small"
                      sx={{
                        mx: 1,
                        '& .MuiInputBase-root': {
                          maxHeight: 32,
                          maxWidth: 64,
                          '& input': { py: 0.5 }
                        }
                      }}
                      InputProps={{ inputProps: { min: 1, max: count || 10 } }}
                    />
                    <Typography variant={'h6'} fontWeight={400} color={'common.black'}>頁</Typography>
                  </>
                )
              }
              
            </Box>
          </Stack>
        )
      }
    </Stack>
  );
}

